import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import TypesTags from "./TypesTags";
import differenceBy from "lodash/differenceBy";

import loading from "../../img/loading.svg";
import Button from "./Button";
import moment from "moment-timezone";

class EmptySlotModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTypes: [],
      customSlotId: "",
      originalSlotTypes: null
    };
  }
  componentWillReceiveProps(newProps) {
    if (newProps.event) {
      this.setState({
        selectedTypes: newProps.event.slotTypes,
        customSlotId: newProps.event.id,
        originalSlotTypes: newProps.event.originalSlotTypes
      });
    }
  }

  handleSelectChange = e => {
    this.setState({
      selectedTypes: e
    });
  };

  createCustomSlot = async () => {
    const startTime = this.props.event.start;
    const doctorId = this.props.doctorId;
    const slotTypesIds = this.state.selectedTypes.map(t => t.id);
    await this.props
      .createCustomSlot({
        variables: { startTime, doctorId, slotTypesIds }
      })
      .then(res => {
        const id = res.data.createCustomSlot.id;
        this.setState({ customSlotId: id }, this.refetchCustomSlots);
      })
      .catch(e => {
        console.error("create custom", e);
      });
  };

  refetchCustomSlots = () => {
    this.props.refetchCustomSlots();
    this.props.toggleModal();
  };

  updateCustomSlot = async () => {
    const id = this.state.customSlotId;
    const slotTypesIds = this.state.selectedTypes.map(t => t.id);
    await this.props
      .updateCustomSlot({
        variables: { id, slotTypesIds }
      })
      .then(res => {
        this.refetchCustomSlots();
      })
      .catch(e => {
        console.error("update custom", e);
      });
  };
  deleteCustomSlot = async () => {
    const id = this.state.customSlotId;
    await this.props
      .deleteCustomSlot({
        variables: { id }
      })
      .then(res => {
        this.refetchCustomSlots();
      })
      .catch(e => {
        console.error("delete custom", e);
      });
  };

  save = () => {
    //  if(this.state.originalSlotTypes )
    if (
      differenceBy(this.state.selectedTypes, this.state.originalSlotTypes, "id")
        .length > 0 ||
      this.state.selectedTypes.length !== this.state.originalSlotTypes.length
    ) {
      if (this.state.customSlotId) {
        //update cs"
        this.updateCustomSlot();
      } else {
        //create cs
        this.createCustomSlot();
      }
    } else {
      if (this.state.customSlotId) {
        //delete cs
        this.deleteCustomSlot();
      } else {
        //do nothing cs
        this.props.toggleModal();
      }
    }
    /*
      if (this.state.customSlotId) {
        this.updateCustomSlot();
      } else {
        this.createCustomSlot();
      }*/
  };

  render() {
    if (!this.props.event) {
      return null;
    }
    return (
      <div className={"modal " + (this.props.isModalOpen ? "is-active" : "")}>
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">
              Slot {moment(this.props.event.start).format("H:mm DD/MM/YYYY")}
            </p>
          </header>
          <section className="modal-card-body">
            <div className="field">
              <label className="label">Types possibles: </label>
              <div className="control">
                {this.props.allSlotTypesQuery.loading ? (
                  <figure className="image is-32x32">
                    <img alt="loading" src={loading} />
                  </figure>
                ) : (
                  <TypesTags
                    selectedTypes={this.state.selectedTypes}
                    allSlotTypes={this.props.allSlotTypesQuery.allSlotTypes}
                    handleTypeTagChange={this.handleSelectChange}
                  />
                )}
              </div>
            </div>
          </section>
          <footer className="modal-card-foot">
            <Button text="Retour" onClick={this.props.toggleModal} />
            <Button color="#00893D" text="Sauvegarder" onClick={this.save} />
          </footer>
        </div>
      </div>
    );
  }
}

const CREATE_CUSTOM_SLOT = gql`
  mutation CreateCustomSlotMutation(
    $startTime: DateTime!
    $doctorId: ID!
    $slotTypesIds: [ID!]
  ) {
    createCustomSlot(
      startTime: $startTime
      doctorId: $doctorId
      slotTypesIds: $slotTypesIds
    ) {
      id
    }
  }
`;

const UPDATE_CUSTOM_SLOT = gql`
  mutation UpdateCustomSlotMutation($id: ID!, $slotTypesIds: [ID!]) {
    updateCustomSlot(id: $id, slotTypesIds: $slotTypesIds) {
      id
    }
  }
`;
const DELETE_CUSTOM_SLOT = gql`
  mutation DeleteCustomSlotMutation($id: ID!) {
    deleteCustomSlot(id: $id) {
      id
    }
  }
`;
const ALL_SLOTTYPES_QUERY = gql`
  query AllSlotTypesQuery($doctorId: ID!) {
    allSlotTypes(
      filter: { AND: [{ doctor: { id: $doctorId } }, { role_not: HIDDEN }] }
      orderBy: index_ASC
    ) {
      id
      name
      duration
      role
      infos
    }
  }
`;

export default compose(
  graphql(CREATE_CUSTOM_SLOT, {
    name: "createCustomSlot"
  }),
  graphql(UPDATE_CUSTOM_SLOT, {
    name: "updateCustomSlot"
  }),
  graphql(DELETE_CUSTOM_SLOT, {
    name: "deleteCustomSlot"
  }),
  graphql(ALL_SLOTTYPES_QUERY, {
    name: "allSlotTypesQuery",
    options: ({ doctorId }) => ({ variables: { doctorId } })
  })
)(EmptySlotModal);



// WEBPACK FOOTER //
// ./src/components/utilities/EmptySlotModal.js